// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--2084d";
export var Content = "styles-module--Content--5a59c";
export var Image = "styles-module--Image--c1882";
export var Navigation = "styles-module--Navigation--d5a95";
export var Title = "styles-module--Title--625cb";